//****************************************
//OBSOLETO
//NON PORTARE AVANTI QUESTA LIBRERIA. PASSARE ALLA VERSIONE 2
//***********************************************************
//Versione 1.6.2  23 Gennaio 2026 - Federico Migliazzi, Nicole Acciai
//                 - NEW: Implementati i memo
//                 - NEW: Gestione colonne nascoste
//                 - NEW: Implementati gli allegati
//Versione 1.5.2  25 Luglio 2024 - Dario Scianna
//                 - FIX: Corretto lo step che non funzionava
//Versione 1.5.1  06 Giugno 2024 - Massimiliano Zirilli
//                 - NEW: Gestito il tipo colore
//Versione 1.4.1  20 Novembre 2023 - Massimiliano Zirilli
//                 - NEW: Gestiti i campi calcolati
//Versione 1.3.1  19 Settembre 2023 - Francesco Ardini
//                 - NEW: Gestiti i DatiEliminabili
//Versione 1.2.1  06 Settembre 2023 - Francesco Ardini
//                 - CHG: Aggiunta la gestione delle liste particolari per riga anche negli autocomplete
//Versione 1.1.1  03 Agosto 2023 - Francesco Ardini
//                 - FIX: Rimosso il name
//                 - NEW: Aggiunti eventi @change per i campi delle righe
//Versione 1.0.0  27 Luglio 2023 - Mauro Brasile
//                 - Prima Versione
<template>
  <VUEConfirm :Popup="PopupDataRow" :Richiesta="'Eliminare la riga selezionata?'" @onClickConfermaPopup="ConfermaElimina" @onClickChiudiPopup="AnnullaElimina">
  </VUEConfirm>
  <template v-for="Colonna in DataTable.Configurazione.Colonne" :Key="Colonna.Id" :style="{ width : Colonna.Larghezza }">
    <td v-if="!Colonna.Nascosta">
      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsString(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <input type="text" class="form-control" @input="CurrentRiga.OnChange(Colonna.Campo)" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" :readonly="Colonna.ReadOnly" :disabled="Colonna.Disabilitato"/>
      </div>
      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsBoolean(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <input type="checkbox" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" @change="OnCheckBoxChange(CurrentRiga,Colonna), CurrentRiga.OnChange(Colonna.Campo)" :readonly="Colonna.ReadOnly" :disabled="Colonna.Disabilitato"/>
      </div>
      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsNumber(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <input type="number" class="form-control" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" :step="CurrentRiga.StepNumber(Colonna.Tipo)" @input="CurrentRiga.OnChange(Colonna.Campo)" :readonly="Colonna.ReadOnly" :disabled="Colonna.Disabilitato"/>
      </div>
      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsSelect(Colonna.Campo)" style="text-align:center;padding-top:6px">
          <div v-if="Colonna.Autocomplete">
              <Autocomplete v-model="CurrentRiga.Dati[Colonna.Campo].Valore"
                          :placeholder="Colonna.Titolo"
                            FieldChiave = "CHIAVE"
                            FieldDescrizione = "DESCRIZIONE"
                          :InvalidValue = "Colonna.DefaultValue"
                            InputClasses="form-control"
                          :items="CurrentRiga.Liste[Colonna.Campo] == undefined ? Colonna.Lista : CurrentRiga.Liste[Colonna.Campo]"
                          :minInputLength="1"
                          @change="CurrentRiga.OnChange(Colonna.Campo)" />
          </div>

          <div v-else>
              <select class="form-control" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" style="cursor:default" :disabled="Colonna.Disabilitato"  @change="CurrentRiga.OnChange(Colonna.Campo)">
                <option v-for="SelectOption in CurrentRiga.Liste[Colonna.Campo] == undefined ? Colonna.Lista : CurrentRiga.Liste[Colonna.Campo]" 
                      :Key="SelectOption[Colonna.SelCampoChiave]"
                      :value="SelectOption[Colonna.SelCampoChiave]">{{SelectOption[Colonna.SelCampoCaption]}}
                </option>
              </select>
          </div>
      </div>
      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsAButton(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <button class="btn btn-sm btn-success" @click="EventoOnClick(CurrentRiga,Colonna)" v-if="!CurrentRiga.Graphics[Colonna.Campo].ButtonContentIsImage">{{ Riga.Graphics[Colonna.Campo].ButtonContent }}</button>
        <img style="height:34px;width:34px;cursor:pointer" :src="Colonna.ButtonContent" @click="EventoOnClick(CurrentRiga,Colonna)" v-if="CurrentRiga.Graphics[Colonna.Campo].ButtonContentIsImage">
      </div>


      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsColor(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <VUEColorPicker :Popup="PopupColorPicker" Programma="" :Colore="ObjColore" @OnClickConfermaPopup="ConfermaColore(CurrentRiga,Colonna)" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>
        <div :style="{'background-color' : CurrentRiga.Dati[Colonna.Campo].Valore, 'width' : '80%', 'margin-left' : '10%'}" @click="OpenColorPopup(CurrentRiga,Colonna)">&nbsp;</div>
      </div>

      <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsDate(Colonna.Campo)" style="text-align:center;padding-top:6px;">
          <input type="date" class="form-control" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" :readonly="Colonna.ReadOnly" :disabled="Colonna.Disabilitato" @change="CurrentRiga.OnChange(Colonna.Campo)"/>
      </div>
      <div v-if="Colonna.CampoCalcolato()" style="text-align:center;padding-top:6px;">
          <label class="ZMLabel" style="text-align:center;height:auto;padding:5px;">{{ GetValoreCampoCalcolato(Colonna) }}</label>
      </div>

     <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsTime(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <input type="time" class="form-control" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" :readonly="Colonna.ReadOnly" :disabled="Colonna.Disabilitato" @change="CurrentRiga.OnChange(Colonna.Campo)"/>
     </div>
     <div v-if="!Colonna.CampoCalcolato() && CurrentRiga.IsDateTime(Colonna.Campo)" style="text-align:center;padding-top:6px;">
        <input type="datetime-local" class="form-control" v-model="CurrentRiga.Dati[Colonna.Campo].Valore" :readonly="Colonna.ReadOnly" :disabled="Colonna.Disabilitato" @change="CurrentRiga.OnChange(Colonna.Campo)"/>
     </div>
      <div v-if="CurrentRiga.IsMemo(Colonna.Campo) && !Colonna.Nascosta" style="text-align:center;padding-top:6px;">
          <textarea v-if="!Colonna.CampoCalcolato()"
                    style="resize:none;overflow-y:hidden;white-space: pre" 
                  :style="{height : CurrentRiga.AltezzaTextArea? CurrentRiga.AltezzaTextArea : '34px'}" 
                    type="text" class="form-control" 
                    v-model="CurrentRiga.Dati[Colonna.Campo].Valore" 
                  :disabled="Colonna.Disabilitato"
                  :readonly="Colonna.ReadOnly || CurrentRiga.RowReadOnly"
                  @input="CheckDimensioniRiga()"/>
          <label class="ZMLabel" v-else style="text-align:center;height:auto;padding:5px;">{{ CalcoloMemo(Colonna) }}</label>
     </div>

     <div v-if="CurrentRiga.IsAllegato(Colonna.Campo) && !Colonna.Nascosta" style="text-align:center;padding-top:6px;" >
        <!-- CARICO ALLEGATO -->
        <button v-if="!CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato"
          @click="OnClickCaricaAllegato(CurrentRiga, Colonna)" 
          data-toggle="class" 
          style=" font-size:17px; cursor:pointer; background:none; border:none; color:black;" 
          title="Carica allegato">
          <i class="fa fa-upload"></i>
        </button>
        <input id="fileLoadDocument" 
              accept="all"
              class="form-control" 
              height=1px
              type="file" 
              style="display: none" />
      
        <!-- SCARICO ALLEGATO -->
        <button v-if="CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato"
          @click="OnClickScaricaAllegato(CurrentRiga, Colonna)" 
          data-toggle="class" 
          style="font-size:17px; cursor:pointer; background:none; border:none; color:green;" 
          title="Apri allegato">
          <i class="fa fa-download"></i>
        </button>
      
        <!-- ELIMINO ALLEGATO -->
        <button v-if="CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato"
          @click="OnClickEliminaAllegato(CurrentRiga, Colonna)" 
          data-toggle="class" 
          style="font-size:17px; cursor:pointer; background:none; border:none; " 
          title="Elimina allegato">
          <i class="fa fa-times-circle" style="color: red;"></i>
        </button>
     </div>
    </td>
  </template>
  <td style="padding-top:6px;">
      <div style="padding-top:6px;float:left;" v-if="CurrentRiga.Modificato()">
       <i v-if="CurrentRiga.RowErrors().length == 0" class="fa fa-check text-success"></i>
      </div>
      <div style="padding-top:6px;float:left;" v-if="CurrentRiga.RowErrors().length > 1">
        <i class="fa fa-times text-danger text" ></i>
      </div>
      <div class="fa-hover" style="padding-top:6px;float:left;" v-if="CurrentRiga.Nuovo">
       &nbsp;<i class="fa fa-file-text text-info text"></i>
      </div>
      <div v-if="!CurrentRiga.Nuovo && !CurrentRiga.Modificato()">&nbsp;</div>
  </td>
  <td v-if="DataTable.DatiEliminabili">
    <div style="padding-top:6px;">
      <i class="fa fa-trash-o text-danger ZMIconButton" @click="OnClickEliminaRiga(CurrentRiga)"></i>
    </div>
  </td>
</template>

<script>
import { TZDateFunct } from './ZDateFunct.js'
import VUEConfirm from './VUEConfirm.vue';
import Autocomplete from './ZAutocomplete.vue';
import VUEColorPicker from './VUEColorPicker.vue';
import { TZGenericFunct } from './ZGenericFunct'
import { TZStringConvFunct } from './ZStringConvFunct.js';

export default 
{
  emits: ['onClick', 'onGetInfoAllegati'],
  props: ['Riga','DataTable'],
  components: { VUEConfirm, Autocomplete, VUEColorPicker },
  data()
  {
     return {
              RigaModal        : null,
              PopupDataRow     : false,
              PopupColorPicker : false,
              ObjColore        : { Colore : '' }
     }
  },
  methods: 
  {
    OpenColorPopup(Riga,Colonna)
    {
      this.ObjColore.Colore = Riga.Dati[Colonna.Campo].Valore
      this.PopupColorPicker = true
    },
    OnClickEliminaRiga(Riga)
    {
      this.RigaModal    = Riga
      this.PopupDataRow = true      
    },
    ConfermaElimina()
    {
      if (this.DataTable.DatiEliminabili)
      {
        this.DataTable.DeleteRow(this.RigaModal)
        this.AnnullaElimina()
      }
    },
    ConfermaColore(Riga,Colonna)
    {
      Riga.Dati[Colonna.Campo].Valore = this.ObjColore.Colore
      this.PopupColorPicker = false
    },
    AnnullaColore()
    {
      this.PopupColorPicker = false
    },
    AnnullaElimina()
    {
       this.PopupDataRow = false
    },
    OnCheckBoxChange(CurrentRiga,Colonna)
    {
     if(Colonna.BoolEsclusivo && CurrentRiga.Dati[Colonna.Campo].Valore)
        this.DataTable.ResetBoolExceptFor(CurrentRiga,Colonna.Campo);
       
    },

    CheckDimensioniRiga()
    {
      let NrRighe = 0
      var Self = this;
      this.DataTable.Configurazione.Colonne.forEach(function(Colonna)
      {
         if(Self.CurrentRiga.IsMemo(Colonna.Campo))
         {
            if(Self.CurrentRiga.Dati[Colonna.Campo].Valore != null && 
               Self.CurrentRiga.Dati[Colonna.Campo].Valore != undefined &&
               typeof Self.CurrentRiga.Dati[Colonna.Campo].Valore === 'string')
            {
               let NrRigheColonna = Self.CurrentRiga.Dati[Colonna.Campo].Valore.split("\n").length; 
               if(NrRigheColonna == 1)
                  NrRigheColonna = Self.CurrentRiga.Dati[Colonna.Campo].Valore.split("/\n/g").length; 
               if(NrRighe < NrRigheColonna)
                  NrRighe = NrRigheColonna
            }
         }
      });
      this.CurrentRiga.AltezzaTextArea = NrRighe  <= 1 ? '34px' : (NrRighe * 22 + 10) + 'px'
    },

    EventoOnClick(Riga,Colonna)
    {
      this.$emit('onClick',Riga,Colonna) 
    },

    OnClickCaricaAllegato(CurrentRiga, Colonna)
    {
      let FileInput = document.getElementById('fileLoadDocument');
      FileInput.click();
      FileInput.addEventListener('change', (event) => 
                                  {
                                    let FileSelezionato = event.target.files[0]

                                    this.NomeAllegato = event.target.files[0].name

                                    if (FileSelezionato)
                                    {
                                      if (CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato == null || CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato == '')
                                      {
                                        const reader = new FileReader()

                                        reader.onload = (event) => {
                                                                      this.File = event.target.result

                                                                      var FileBase64 = event.target.result.split("base64,")

                                                                      CurrentRiga.Dati[Colonna.Campo].FileBase64 = FileBase64
                                                                      CurrentRiga.Dati[Colonna.Campo].Valore = FileBase64[1]
                                                                      CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato = this.NomeAllegato
                                                                    }
                                        reader.readAsDataURL(FileSelezionato)
                                      }
                                    }
                                    
                                  }, { once: true })

    },

    OnClickScaricaAllegato(CurrentRiga, Colonna)
    {
      let Parametri = {
                    CurrentRiga : CurrentRiga,
                    Colonna : Colonna
                  }
      this.$emit('onGetInfoAllegati', Parametri) 
    },

    OnClickEliminaAllegato(CurrentRiga, Colonna)
    {
      if(CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato)
      {
        CurrentRiga.Dati[Colonna.Campo].PosizioneAllegato = null
        CurrentRiga.Dati[Colonna.Campo].Valore = null
      }
    },

    GetValoreCampoCalcolato(Colonna)
    {
         return this.DataTable.GetValoreCampoCalcolato(this.Riga,Colonna)
    },

    CalcoloMemo(Colonna)
    {
      return Colonna.OnCalcoloValore(this.Riga.Dati)
    },
  },

  computed: 
  {
     CurrentRiga : 
     { 
        get() {
          return this.Riga;
        }
     },
     RigaModificata :
     {
        get()
        {
           return JSON.stringify(this.Riga.Dati) != this.Riga.StartData;
        }
     },
  },
  mounted()
  {
    this.CheckDimensioniRiga()
  } 

}
</script>